import React from "react";

import "./style.scss";

const CustomToolTip = ({ active, payload, label }) => {
  const { payload: data } = payload[0] || {};

  if (active && data && payload.length)
    return (
      <div className="custom-tooltip">
        {Object.entries(data).map(([key, value]) => (
          <p key={key}>
            <span>{key}</span>: <b>{value}</b>
          </p>
        ))}
      </div>
    );
};

export default CustomToolTip;
